export const CRQ_CONFIG_TYPES = {
  CRQ_CONFIG_PARAMETER: 'crqConfigParameter',
  CRQ_DETAIL: 'crqDetail',
};

export const CRQ_CONFIG_PARAMS = [
  'QUERY_FEDERATION',
  'DATASET_MATERIALIZATION',
  'DISABLE_IDENTIFIER_PROJECTION',
  'RUN_CONFIG_OVERRIDES',
  'RUN_CONNECTOR',
  'STORAGE_OVERRIDES',
  'LOG_SNOWFLAKE_TRANSCODING_ERRORS',
  'CAPTURE_SNOWFLAKE_TRANSCODING_METRICS',
  'BILLABLE',
  'PRODUCT_OPTIMIZATION',
  'RETAIN_UNMATCHED_RECORDS',
  'SKIP_TRANSCODING_VALIDATION_FOR_ANALYTICAL_QUESTION',
  'CLEAN_COMPUTE_TRANSCODING_SUMMARY',
  'ENABLE_DATABRICKS_DATA_PLANE',
];

// Add validation map for each param
export const CRQ_CONFIG_VALIDATION_MAP = {
  QUERY_FEDERATION: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
  DATASET_MATERIALIZATION: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
  DISABLE_IDENTIFIER_PROJECTION: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
  RUN_CONNECTOR: {
    allowedValues: ['HYBRID_PG'],
    errorMessage: 'Value must be HYBRID_PG',
  },
  RUN_CONFIG_OVERRIDES: {
    errorMessage: 'Value must be comma-separated spark key=value pairs\n E.g "spark.executor.cores=2,spark.executor.memory=88g"',
    validate: (value) => {
      const isValid = value.trim() === '' || value.split(',').every(pair => {
        const [key, val] = pair.split('=');
        return key && val && key.startsWith('spark.') && !/\s/.test(pair);
      });
      return isValid;
    },
  },
  STORAGE_OVERRIDES: {
    errorMessage: 'Value must be like 110Gi, 1Gi etc',
    validate: (value) => /^\d+[KMGT]i$/.test(value),
  },
  BILLABLE: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
  RETAIN_UNMATCHED_RECORDS: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
  SKIP_TRANSCODING_VALIDATION_FOR_ANALYTICAL_QUESTION: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
  CLEAN_COMPUTE_TRANSCODING_SUMMARY: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
  ENABLE_DATABRICKS_DATA_PLANE: {
    allowedValues: ['true', 'false'],
    errorMessage: 'Value must be either true or false',
  },
};

export const QUERY_LANG_TO_SUBTYPE = {
  SQL: 'SQL',
  CLEAN_COMPUTE: 'Clean Compute',
  CLEAN_COMPUTE_ON_SPARK: 'Clean Compute on Spark',
};

export const getCrqConfigs = (qDetails, crqConfigParams, computeCapacity = 'Unknown') => [
  {
    name: 'title',
    value: qDetails?.title,
    type: CRQ_CONFIG_TYPES.CRQ_DETAIL,
  },
  {
    name: 'computeCapacity',
    value: computeCapacity,
    type: CRQ_CONFIG_TYPES.CRQ_DETAIL,
  },
  {
    name: 'category',
    value: qDetails?.category,
    type: CRQ_CONFIG_TYPES.CRQ_DETAIL,
  },
  {
    name: 'subtype',
    value: QUERY_LANG_TO_SUBTYPE[qDetails?.queryDetails?.[0]?.queryLanguage] || 'Unknown',
    type: CRQ_CONFIG_TYPES.CRQ_DETAIL,
  },
  ...(crqConfigParams?.crqConfigParameters?.map(param => ({
    name: param.parameterName,
    value: param.parameterValue,
    type: CRQ_CONFIG_TYPES.CRQ_CONFIG_PARAMETER,
  })) || []),
];
